import * as React from "react";
import {
    List,
    Show,
    Edit,
    Create,

    Datagrid,
    SimpleShowLayout,
    SimpleForm,
    TextField,
    EmailField,
    DateField,
    TextInput,
    DateInput,
    BooleanField,
    ArrayField,
    SelectField,
    SelectInput,

    FileField,
    FileInput,

    SaveButton,
    Toolbar,

    TabbedShowLayout,
    Tab,
    ImageField,
    WrapperField,
    RichTextField,
    FunctionField,
    useRecordContext,
    UrlField,
    ArrayInput,
    SimpleFormIterator,
    ReferenceInput,
    AutocompleteInput,
} from 'react-admin';
import { useController, useForm } from "react-hook-form";
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { RichTextInput } from "ra-input-rich-text";
import { getFriendlySettingName, getSettingDescription, hasJsonStructure } from "../helpers/strings";
// import { QuizzBuilder, Quiz } from "react-quizzes"
// import "react-quizzes/lib/assets/antd.css";
// import "./Forms.css";

const SettingList = props => (
    <List title={"All Settings"} {...props}>
        <Datagrid rowClick="show" bulkActionButtons={false}>
            {/* <TextField source="id" /> */}
            <FunctionField label="Name" render={record => getFriendlySettingName(record.name)} />
        </Datagrid>
    </List>
);

const SettingViewer = (props) => {
    const record = useRecordContext(props);

    if(!record) {
        return null;
    }

    let isArray = false;
    let vals = [];
    if(hasJsonStructure(record.value)) {
        isArray = true;
        vals = JSON.parse(record.value);
    } else if (typeof record.value === 'object' && Array.isArray(record.value)) {
        isArray = true;
        vals = record.value;
    }

    if(record.name === 'active_form') {
        return (
            <TextField source="object.name" />
        );
    }

    if(isArray) {
        return (
            <ArrayField source="value">
                <Datagrid bulkActionButtons={false}>
                    <TextField source="name" />
                    <TextField source="link" />
                </Datagrid>
            </ArrayField>
        );
        return (
            <FunctionField label="Value" component="pre" render={record => {
                let value = '';
                // TODO: detect object vs array
                for(const entry of vals) {
                    value += `Button: ${entry.name} (${entry.link})\n\n`;
                }

                return value;
            }}/>
        );
    }

    return (<TextField source="value" />);
}

const SettingShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <FunctionField label="Name" render={record => getFriendlySettingName(record.name)} />
            <FunctionField label="Description" render={record => getSettingDescription(record.name)} />
            <SettingViewer source="value" />
        </SimpleShowLayout>
    </Show>
)

const SettingEditor = () => {
    const record = useRecordContext();
    const input = useController({name: 'value'});

    let isArray = false;
    let vals = [];
    if(hasJsonStructure(input.field.value)) {
        isArray = true;
        vals = JSON.parse(input.field.value);
    } else if (typeof input.field.value === 'object' && Array.isArray(input.field.value)) {
        isArray = true;
        vals = input.field.value;
    }

    if(record.name === 'active_form') {
        return (
            <ReferenceInput
                source="value"
                reference="forms"
            >
                <AutocompleteInput optionText={'name'} />
            </ReferenceInput>
        );
    }

    if(isArray) {
        return (
            <ArrayInput source="value">
                <SimpleFormIterator>
                    <TextInput source="name" />
                    <TextInput source="link" />
                </SimpleFormIterator>
            </ArrayInput>
        );
    }

    return (<TextInput source="value" required multiline fullWidth />);


    // todo: determine if it's a string or json
    if(input.field.value) {
        //
    }
    /*
    return (
      <>

      <ReactFormeoEditor
        formData={input.field.value}
        onChange={(data) => {
          // setFormData(data);
          input.field.onChange(data);
        }}
      />
      </>
    );
    */
}

const EditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

const SettingEdit = props => {console.log(props);return(
    <Edit {...props} redirect="show" mutationMode="pessimistic">
        <SimpleForm toolbar={<EditToolbar />}>
            <FunctionField label="Name" render={record => getFriendlySettingName(record.name)} />

            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Stack>
                        <SettingEditor source="value" required />
                    </Stack>
                </Grid>
            </Grid>

        </SimpleForm>
    </Edit>
)};

export {SettingList, SettingShow, SettingEdit};
